import React from 'react';

// Mobile replacement for a table row. Use onClick OR actions, never both
// (a clickable card is a <button>, and buttons cannot nest).
const ListCard = ({ title, subtitle, amount, amountTone = 'text-slate-900', meta, badge, onClick, actions }) => {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className="block w-full text-left bg-white rounded-2xl border border-slate-200 p-4 active:bg-slate-50"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-sm font-semibold text-slate-900 truncate">{title}</div>
          {subtitle && <div className="text-xs text-slate-500 truncate mt-0.5">{subtitle}</div>}
        </div>
        {amount != null && <div className={`text-sm font-semibold tabular-nums shrink-0 ${amountTone}`}>{amount}</div>}
      </div>
      {(meta || badge) && (
        <div className="flex items-center justify-between gap-2 mt-2">
          <div className="text-xs text-slate-500 truncate">{meta}</div>
          {badge}
        </div>
      )}
      {actions && <div className="flex justify-end gap-2 mt-3 pt-3 border-t border-slate-100">{actions}</div>}
    </Tag>
  );
};

export const ListCards = ({ children }) => <div className="md:hidden space-y-2">{children}</div>;

// Small button for ListCard actions.
export const CardAction = ({ children, tone = 'default', ...props }) => {
  const tones = { default: 'text-slate-700 bg-slate-100', danger: 'text-red-600 bg-red-50', primary: 'text-blue-700 bg-blue-50' };
  const Tag = props.href ? 'a' : 'button';
  return (
    <Tag type={props.href ? undefined : 'button'} {...props}
      className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-lg text-sm font-medium ${tones[tone]}`}>
      {children}
    </Tag>
  );
};

export default ListCard;
